var map = {
	"./ar/languages.json": 3571,
	"./de/languages.json": 4643,
	"./en/languages.json": 5165,
	"./es/languages.json": 2054,
	"./fr/languages.json": 5745,
	"./pt/languages.json": 9228,
	"./ru/languages.json": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2098;